/* eslint-disable */
import React from 'react';
import { Doughnut,Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { color } from 'echarts';

ChartJS.register(ArcElement, Tooltip, Legend);

const RecordToReportPieChart = ({ filedBy, filedAgainst, Labels }) => {

  const totalValue = filedBy + filedAgainst;

  const data = {
    labels: Labels,
    datasets: [
      {
        data: [filedBy, filedAgainst],
        backgroundColor: ['#2b5797', '#c9def4'],
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
          color: '#000',
          font: {
            family: 'sans-serif',
            size: 12,
          },
        },
      },
      datalabels: {
        color: '#ffffff',
        font: {
          weight: 'bold',
          size: 11
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '210px', height: '200px', margin: '0 auto' }}>
      <Doughnut data={data} options={options} />
        {totalValue === 0 && (
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#000',
                pointerEvents: 'none'
            }}>
                0
            </div>
        )}
    </div>

  );
};

export default RecordToReportPieChart;
